export default __webpack_public_path__ + "static/media/girl-eating@2x.dbd15557.png";